import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';

import api from '@/api';

export default {
    extends: api,
    props: ["callSunday"],
    data() {
        return {
            keyPaymentMethod: 0,
            optionPaymentSelected: 1,
            labelSend: this.$t('sendReserve'),
            paymentMethods: [],
            paymentMethodSelected: null
        }
    },
    computed: {
        ...mapGetters(['getState', 'getToken', 'getDesign', 'getCheckout', 'getExperiences', 'getExperiencesCheckout', 'getPaymentMethods', 'getDateSelected']),
        getTotalPriceCalcutate: function () {
            let total = 0;
            const checkout = this.getCheckout();
            checkout.items.forEach((item) => {
                total += Number(item.price_original);
                item.fields.forEach((field) => {
                    if (field.name.includes('*')) {
                        total += field.amount * item.people_number;
                    } else if (!field.name.includes('=')) {
                        total += field.amount;
                    }
                });
            });

            const filedsPerReservation = checkout.items.map(i => i.fields).flat().filter(x => x.name.includes("+="));
            // Los campos que se cobran por reserva solo se deneben de cobrar una vez pero la estrucutra de datos pone varios por cada item
            const extraPerReservation = this.unique(filedsPerReservation).reduce((total, item) => total + item.amount, 0);

            if (extraPerReservation) {
                // Se multiplica por el numero de elemtos porque el backend fuerza a que se le mande repartidos los items por reserva
                total += (extraPerReservation * checkout.items.length);
            }

            return parseFloat(total).toFixed(2);
        },
        getFractionedPriceCalcutate: function () {
            let total = 0;
            this.getCheckout().items.map((item) => {
                total += item.price_fractioned;
            });
            return parseFloat(total).toFixed(2);
        },
        getTotalPriceAfterDiscount: function () {
            return parseFloat(this.getCheckout().price_after_discount).toFixed(2);
        },
        /*
        Los gastos de gestion los calcula el servidor sobre el total y llegan en la respuesta de
        postPurchase/patchPurchase, asi que aqui solo se leen. No se recalculan en el navegador para
        que no puedan discrepar del importe que se acaba cobrando.
        Las instancias de aion sin la funcionalidad de comision no mandan el campo (o lo mandan a
        null/""), asi que cualquier valor no numerico cuenta como 0 y el resumen queda como antes.
        */
        getManagementFeeAmount: function () {
            const fee = parseFloat(this.getCheckout().management_fee_amount);
            return Number.isFinite(fee) && fee > 0 ? fee : 0;
        },
        hasManagementFee: function () {
            // Sin compra creada el total se calcula en local y no lleva comision; mostrarla desencajaria.
            return Boolean(this.getCheckout().id) && this.getManagementFeeAmount > 0;
        },
        getTotalWithManagementFee: function () {
            return (parseFloat(this.getCheckout().price_after_discount || 0) + this.getManagementFeeAmount).toFixed(2);
        },
        /*
        Lo que se cobra ahora: la reserva entera o solo la senal, mas los gastos de gestion, que se
        cobran completos en el primer pago aunque el resto quede pendiente.
        */
        getAmountToPayNow: function () {
            const base = this.optionPaymentSelected == 2
                ? parseFloat(this.getCheckout().price_fractioned || 0)
                : parseFloat(this.getCheckout().price_after_discount || 0);

            return (base + this.getManagementFeeAmount).toFixed(2);
        },
        isPartialPrice: function () {
            let isPartialPrice = [];
            this.getExperiencesCheckout().map((experience) => {
                isPartialPrice.push(experience.prices.partial_price);
            });

            return isPartialPrice.some((value) => value !== 0);
        },
        isForcePartial: function () {
            let isForcePartialComplete = [];
            this.getExperiencesCheckout().map((experience) => {
                isForcePartialComplete.push(experience.prices.force_partial);
            });
            let all = isForcePartialComplete.every((value) => value == true);
            if (all) {
                if (this.getTotalPriceAfterDiscount > 0) {
                    this.optionPaymentSelected = 2;
                    this.changeTotalToPaid(2);
                }
                else {
                    this.optionPaymentSelected = 1;
                    all = false;
                    this.changeTotalToPaid(1);
                }
            }
            return all;
        }
    },
    watch: {
        optionPaymentSelected: function () {
            this.changeTotalToPaid(this.optionPaymentSelected);
        },
    },
    methods: {
        ...mapMutations(['updateCheckoutField', 'updateCheckout', 'updateCheckoutPartial']),
        changePaymentMethod: function (value) {
            this.paymentMethodSelected = value;
        },
        finishPurchase: function () {
            if (this.validate()) {
                if (this.getTotalPriceAfterDiscount <= 0) {
                    this.changeTotalToPaid(1);
                }
                let updatePurchasePromise = new Promise((resolve) => {
                    this.updatePurchaseApi(resolve);
                });
                updatePurchasePromise.then((purchase) => {
                    this.disablePopUpClose();
                    let preparePaymentPromise = new Promise((resolve) => {
                        this.preparePaymentMethodApi(this.paymentMethodSelected.paymentMethodId, resolve);
                    });
                    preparePaymentPromise.then((payment) => {
                        this.$emit('change-payment-method', { payment: payment, paymentMethodId: this.paymentMethodSelected.paymentMethodId, paymentMethodType: this.paymentMethodSelected.paymentMethodType });
                        document.getElementById('submit-purchase').click();
                    });
                });
            }
        },
        copyClipboard: function () {

            let idPurchase = this.getCheckout().id;

            if (idPurchase) {
                this.labelSend = this.$t('clicSendDone');
                navigator.clipboard.writeText(window.location.href + '?checkout=' + idPurchase + '&dateSelected=' + this.getDateSelected());
            }
            else {
                this.labelSend = this.$t('notReservedDone');
            }
        },
        changeTotalToPaid: function (optionPaymentId) {
            this.updateCheckoutPartial({ is_fractioned: optionPaymentId == 2 });
        },
        disablePopUpClose: function () {
            window.onbeforeunload = function () { };
        },
        validate: function () {
            const requiredFields = Array.from(document.getElementsByClassName("required-field"));

            let isValid = true;
            let isValidatedField = false;
            for (const field of requiredFields) {
                if (!field.value) {
                    isValid = false;
                    field.classList.add('input-error');

                    if (!isValidatedField) {
                        field.scrollIntoView();
                        isValidatedField = true;
                    }
                }
            }

            return isValid;
        },
        unique: function (fields) {
            let uniques = new Map();

            for (let i = 0; i < fields.length; i++) {
                let field = fields[i];
                let key = `${field.name}-${field.title}-${field.total}-${field.value}`;
                if (!uniques.has(key)) {
                  uniques.set(key, field);
                }
                
            }

            return Array.from(uniques.values());
        }
    }

}